import { render, staticRenderFns } from "./ImportScreenRow.vue?vue&type=template&id=146f15a2"
import script from "./ImportScreenRow.vue?vue&type=script&lang=js"
export * from "./ImportScreenRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports